/* ========================== SalaryList Component ========================== */
import React, { useState } from "react";
import { EmployeeSalary } from "../types/EmployeeSalary";
import { Button, OverlayTrigger, Popover, Table } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import "../styles/EmployeeList.css";
import { Edit, Paperclip, Trash } from "lucide-react";
import { Eye } from "react-feather";

interface SalaryListProps {
  salaryList: EmployeeSalary[];
  onEdit?: (data: EmployeeSalary) => void;
  onDelete?: (id: number) => void;
}

const EmployeeSalaryList: React.FC<SalaryListProps> = ({
  salaryList,
  onEdit,
  onDelete,
}) => {
  const [selectedEmployeeId, setSelectedEmployeeId] = useState<string | null>(
    null,
  );
  const navigate = useNavigate();

  if (!Array.isArray(salaryList)) {
    console.error("Expected salaryList to be an array but got:", salaryList);
    return <div>No data available.</div>;
  }
  const totalBP = salaryList.reduce((sum, item) => sum + item.bp, 0);
  const totalHRA = salaryList.reduce((sum, item) => sum + item.hra, 0);
  const totalTax = salaryList.reduce((sum, item) => sum + item.tax, 0);
  const totalPF = salaryList.reduce((sum, item) => sum + item.pf, 0);
  const totalTA = salaryList.reduce((sum, item) => sum + item.ta, 0);
  const totalSA = salaryList.reduce((sum, item) => sum + item.sa, 0);
  const totalLOP = salaryList.reduce((sum, item) => sum + item.lop, 0);
  const totalNet = salaryList.reduce((sum, item) => sum + item.netAmount, 0);

  const filteredSalaryLog = selectedEmployeeId
    ? salaryList.filter((s) => s.employeeId === selectedEmployeeId)
    : [];

  const handleAttachment = (employeeId: string) => {
    navigate(`/salaryMasterLog/${employeeId}`);
  };

  const salaryPopOver = (
    <Popover id="popover-view">
      <Popover.Body>Salary Log</Popover.Body>
    </Popover>
  );
  return (
    <div>
      <Table className="custom-employee-table" responsive>
        <thead>
          <tr>
            <th>Employee ID</th>
            <th>Year</th>
            <th>Month</th>
            <th>BP</th>
            <th>HRA</th>
            {/* <th>Tax</th> */}
            <th>PF</th>
            <th>TA</th>
            <th>SA</th>
            <th>LOP</th>
            <th>Net Amount</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {[...salaryList]
            .sort((a, b) => b.id - a.id)
            ?.map((salary) => {
              console.log("data", salary.month);
              console.log("d", salary);
              return (
                <tr key={salary.id}>
                  <td>{salary.employeeId}</td>
                  <td>{salary.year}</td>
                  <td>{salary.month}</td>
                  <td>{salary.bp}</td>
                  <td>{salary.hra}</td>
                  {/* <td>{salary.tax}</td> */}
                  <td>{salary.pf}</td>
                  <td>{salary.ta}</td>
                  <td>{salary.sa}</td>
                  <td>{salary.lop}</td>
                  <td>{salary.netAmount}</td>
                  <td>
                    <OverlayTrigger
                      trigger={["hover", "focus"]}
                      placement="top"
                      overlay={salaryPopOver}
                    >
                      <span>
                        <Button
                          className="btn btn-sm text-white"
                          style={{
                            backgroundColor: "#10296C",
                            padding: "5px",
                            borderRadius: "5px",
                            marginRight: "5px",
                          }}
                          onClick={() => handleAttachment(salary.employeeId)}
                        >
                          <Eye style={{ width: "25px" }} />
                        </Button>
                      </span>
                    </OverlayTrigger>
                    <Button
                      variant="warning"
                      onClick={() => onEdit?.(salary)}
                      style={{
                        padding: "5px",
                        borderRadius: "5px",
                      }}
                      className="mr-2"
                    >
                      <Edit />
                    </Button>
                    <Button
                      variant="danger"
                      onClick={() => onDelete?.(salary.id)}
                      style={{
                        padding: "5px",
                        borderRadius: "5px",
                      }}
                    >
                      <Trash />
                    </Button>
                  </td>
                </tr>
              );
            })}
          <tr style={{ fontWeight: "bold" }}>
            <td colSpan={3}>Total</td>
            <td>{totalBP}</td>
            <td>{totalHRA}</td>
            {/* <td>{totalTax}</td> */}
            <td>{totalPF}</td>
            <td>{totalTA}</td>
            <td>{totalSA}</td>
            <td>{totalLOP}</td>
            <td>{totalNet}</td>
          </tr>
        </tbody>
      </Table>
    </div>
  );
};

export default EmployeeSalaryList;
